import React, {Component} from 'react';
import {
    Button,
    Card,
    Dimmer,
    Image,
    Loader,
    Modal,
    Form,
    Radio,
    Table, Checkbox,
} from 'semantic-ui-react';
import {FormattedNumber} from "react-intl";
import {connect} from "react-redux";
import {addProduct, updateQuantity} from "../../actions/ProductsSaleActions";
import SaleItemData from "../../data/SaleItemData";
import {totalSale} from "../../actions/SaleTotalAction";
import {showToast} from "../../actions/ToastAction";
import localDB from "../../data/localDB";


function makeVariants(product){
    let variants = []
    if(product.product_type === 'K'){
        product.combo.map(combo =>{
            if(combo.additional.product_type === 'V'){
                variants.push({product: combo.additional.id, variant: combo.additional.get_product_variants.length > 0 ? combo.additional.get_product_variants[0].id:null, checked: true})
            }else{
                variants.push({product: combo.additional.id, variant: null, checked: true})
            }
        })
    }else if(product.product_type === 'V'){
        product.get_other_product_variants.map(variant =>{
            variants.push({product: variant.product.id, variant: variant.variants.length > 0 ? variant.variants[0].id:variant.product.id, checked: true})
        })
    }
    return variants
}

class ProductOrderCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            product: props.product,
            sale_id: props.sale_id,
            sending: false,
            search_by_barcode: props.search_by_barcode,
            show_modal: false,
            products_variant:[],
            selected_variants: [],
            selected_variant: props.product.get_product_variants.length > 0 ? props.product.get_product_variants[0].id:null,
            variants: makeVariants(props.product),
            additions: {},
            compounds:[]
        };
        this.handleSelectProduct = this.handleSelectProduct.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleChangeChecked = this.handleChangeChecked.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search_by_barcode !== this.props.search_by_barcode && this.props.search_by_barcode) {
          this.handleSelectProduct();
        }
    }

    async handleSelectProduct() {
        if(this.state.product.product_type === 'V'){
            let products = await Promise.all(this.state.product.get_product_variants.map((variant)=>localDB.findProduct(variant)))
            let other_variants = await Promise.all(this.state.product.get_other_product_variants.map(async (variant)=>{
                return {
                    product: await localDB.findProduct(variant.product),
                    variants: await Promise.all(variant.variants.map((variant)=>localDB.findProduct(variant)))
                }
            }))
            this.setState({products_variant:[{product:this.state.product, variants:products, other_variants: other_variants}], show_modal: true})
        }
        else if(this.state.product.product_type === 'K'){
            let product = await localDB.findProduct(this.state.product.id)
            let additionals = product.combo.filter((combo) => combo.additional.product_type ==='V')
            if(additionals.length > 0){
                let products = await Promise.all(additionals.map((combo)=>localDB.findProduct(combo.additional.id)))
                let product_variants = await Promise.all(this.state.product.get_product_variants.map((variant)=>localDB.findProduct(variant)))
                let products_variant = []
                products.map((product, index) => {
                    return products_variant.push({product, variants:product_variants[index]})
                })
                this.setState({products_variant, show_modal: true})
            }else{
                this.setState({sending: true, search_by_barcode:false});
                let data = {sale: this.state.sale_id, product: this.state.product.id, quantity: -1, variants:this.state.variants};
                this.addSaleItem(data)
            }
        }else if(this.state.product.get_additions.length > 0){
            this.setState({show_modal: true})
        }else{
            this.setState({sending: true, search_by_barcode:false});
            let data = {sale: this.state.sale_id, product: this.state.product.id, quantity: -1, variants:[]};
            this.addSaleItem(data)
        }
    }

    addSaleItem(data){
        data['additions'] = Object.keys(this.state.additions).length !== 0 ? this.state.additions:null
        SaleItemData.add(data, (res) => {
            if (res !==null && res.save) {
                if (res.type === 1) {
                    this.props.addProduct(res.data);
                    res.additions.map((res_addition) =>{
                        if(res_addition.type === 1){
                            this.props.addProduct(res_addition.addition);
                        }else{
                            res_addition.addition.quantity = data['additions'][res_addition.addition.product.id];
                            this.props.updateQuantity(res_addition.addition);
                        }
                    });
                } else {
                    data.id = res.id;
                    data.quantity = data.quantity * -1;
                    res.additions.map((res_addition) =>{
                        if(res_addition.type === 1){
                            this.props.addProduct(res_addition.addition);
                        }else{
                            res_addition.addition.quantity = data['additions'][res_addition.addition.product.id];
                            this.props.updateQuantity(res_addition.addition);
                        }
                    });
                    this.props.updateQuantity(data);
                }
                this.props.totalSale(res.total);
            } else {
                this.props.showToast({message: res ? res.message:'Tenemos un problema!', type: 'error'})
            }
            this.setState({sending: false, additions:{}});
        });
    }

    handleCloseModal(){
        this.setState({
            show_modal: false,
            products_variant:[],
            selected_variants:[],
            additions:{},
            compounds:[],
            selected_variant: this.props.product.get_product_variants.length > 0 ? this.props.product.get_product_variants[0].id:null,
            variants: makeVariants(this.props.product),
        })
    }

    handleChangeVariant(product_id, variant_id, main_variant=false, clean_variants=false){
        if(main_variant){
            let variants = clean_variants ? []:this.state.variants;
            this.setState({selected_variant: variant_id, variants})
        }else{
            let variants = clean_variants ? []:this.state.variants;
            let index = this.state.variants.findIndex((variant) => variant.product === product_id)
            variants[index].variant = variant_id
            this.setState({variants})
        }
    }

    handleChangeCompounds(compound_id){
        let compounds = this.state.compounds;
        if(compounds.includes(compound_id)){
            compounds = compounds.filter(id => id !== compound_id)
        }else{
            compounds.push(compound_id)
        }
        this.setState({compounds})
    }

    selectVariants(){
        let data = {
            sale: this.state.sale_id,
            product: this.state.product.id,
            quantity: -1,
            variants: this.state.variants,
            without_compounds: this.state.compounds,
            variant: this.state.selected_variant
        };
        this.setState({data})
        this.handleCloseModal()
        this.addSaleItem(data)
    }

    handleChangeChecked(product_id){
        let variants = this.state.variants;
        let index = this.state.variants.findIndex((variant) => variant.product === product_id)
        variants[index].checked = !variants[index].checked
        this.setState({variants})
    }

    handleChangeAdditionQuantity = (addition_id, quantity) => {
        let additions = this.state.additions
        if(additions.hasOwnProperty(addition_id)){
            additions[addition_id] += quantity
        }else{
            additions[addition_id] = quantity
        }
        if(additions[addition_id] <= 0 || quantity === 0){
            delete additions[addition_id]
        }
        this.setState(additions)
    };

    render() {
        return (
            <React.Fragment>
                <Card key={this.state.product.id} onClick={this.state.sending ? null : this.handleSelectProduct}>
                    <Image src={`${this.state.product.image}?tr=w-300,ar-16-9`} style={{height: '6.6em', objectFit: 'cover', width:'100%'}}/>
                    <Card.Content>
                        <Card.Description>
                            {this.state.product.name}
                        </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                        <strong className='orange'>
                            {this.state.product.price_from ? 'Desde ':null}
                            $<FormattedNumber value={this.state.product.price_from ? this.state.product.price_from:this.state.product.sale_price}
                                              currency="USD"
                                              maximumFractionDigits={0}
                                              minimumFractionDigits={0}/>
                        </strong>
                    </Card.Content>
                    <Dimmer active={this.state.sending} inverted>
                        <Loader size='mini'>Agregando</Loader>
                    </Dimmer>
                </Card>
                <Modal open={this.state.show_modal} size='tiny' dimmer='inverted' onClose={() => this.handleCloseModal()}>
                    <Modal.Header>{this.state.product.name}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.state.product.product_type === 'V' ? <React.Fragment>
                                <h3>Opciones</h3>
                                {this.state.product.get_product_variants.map(variant =>{
                                return <Form.Field
                                key={variant.id}
                                control={Radio}
                                label={variant.name.toUpperCase()}
                                value={variant.id}
                                checked={variant.id === this.state.selected_variant}
                                onChange={() => this.handleChangeVariant(this.state.product.id, variant.id, true)}
                                />
                            })}
                            {this.state.product.product_type === 'V' ? this.state.product.get_other_product_variants.map(other_product_variants =>{
                                return <React.Fragment>
                                    {other_product_variants.variants.length > 0 ? <React.Fragment>
                                        <h3>{other_product_variants.product.name}</h3>
                                        {other_product_variants.variants.map(variant =>{
                                            return <Form.Field
                                                key={variant.id}
                                                control={Radio}
                                                label={variant.name.toUpperCase()}
                                                value={variant.id}
                                                checked={this.state.variants.find((selected) => selected.variant === variant.id && selected.product === other_product_variants.product.id) !== undefined}
                                                onChange={() => this.handleChangeVariant(other_product_variants.product.id, variant.id)}
                                            />
                                        })}
                                    </React.Fragment>:<h3>
                                        <Form.Field
                                            label={other_product_variants.product.name}
                                            control={Radio}
                                            checked={other_product_variants.product.id === this.state.selected_variant}
                                            onChange={() => this.handleChangeVariant(this.state.product.id, other_product_variants.product.id, true, true)}
                                        />
                                    </h3>}
                                </React.Fragment>
                            }):null}
                            </React.Fragment>:null}
                            {this.state.product.combo && this.state.product.product_type === 'K' ? this.state.product.combo.filter(combo_option => combo_option.additional.get_product_variants.length > 0).map(combo_option =>{
                                return <React.Fragment>
                                    <h3>{combo_option.additional.name}</h3>
                                    {combo_option.additional.get_product_variants.map((variant) =>{
                                        return <Form.Field
                                        key={variant.id}
                                        control={Radio}
                                        label={variant.name.toUpperCase()}
                                        value={variant.id}
                                        checked={this.state.variants.find((selected) => selected.variant === variant.id && selected.product === combo_option.additional.id) !== undefined}
                                        onChange={() => this.handleChangeVariant(combo_option.additional.id, variant.id)}
                                        />
                                    })}
                                </React.Fragment>
                            }):null}
                            {this.state.product.get_additions.length > 0? <React.Fragment>
                                <h3>Adicionales</h3>
                                <Table>
                                    {this.state.product.get_additions.map(addition =>{
                                        return <Table.Row>
                                            <Table.Cell>
                                                <Button.Group size='small'>
                                                    <Button icon='minus' onClick={() => this.handleChangeAdditionQuantity(addition.id, -1)}/>
                                                    <Button content={this.state.additions[addition.id] ? this.state.additions[addition.id]:0} active />
                                                    <Button icon='plus' onClick={() => this.handleChangeAdditionQuantity(addition.id, 1)}/>
                                                </Button.Group>
                                            </Table.Cell>
                                            <Table.Cell>
                                                {addition.product}
                                            </Table.Cell>
                                            <Table.Cell>
                                                <Button icon='trash' onClick={() => this.handleChangeAdditionQuantity(addition.id, 0)}/>
                                            </Table.Cell>
                                        </Table.Row>
                                    })}
                                </Table>
                            </React.Fragment>:null}
                            {this.state.product.can_excluded_compounds.length > 0? <React.Fragment>
                                <h3>Opcionales</h3>
                                {this.state.product.can_excluded_compounds.map(compound =>{
                                    return <Form.Field
                                        key={compound.id}
                                        control={Checkbox}
                                        label={compound.compound.toUpperCase()}
                                        value={compound.id}
                                        checked={!this.state.compounds.includes(compound.id)}
                                        onChange={() => this.handleChangeCompounds(compound.id)}
                                    />
                                })}
                            </React.Fragment>:null}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={() => this.handleCloseModal()} content="Cancelar"/>
                        <Button primary icon='save' onClick={() => this.selectVariants()} labelPosition='left' content={'Agregar'}/>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        addProduct(product) {
            dispatch(addProduct(product));
        },
        updateQuantity(product) {
            dispatch(updateQuantity(product));
        },
        totalSale(total) {
            dispatch(totalSale(total))
        },
        showToast(data) {
            dispatch(showToast(data));
        }
    }
};

export default connect(
    null,
    mapDispatchToProps
)(ProductOrderCard);




// WEBPACK FOOTER //
// ./src/components/sale/ProductOrderCard.js